export const quickActionsTypes = {
  DOWNLOAD: 'download',
  VIEW: 'view',
};
